export const FREE_ROOM_MESSAGE =
  'Free Room. Anyone can deploy virtual machines in the room (without being subscribed)!';
export const SUBSCRIBED_ROOM_MESSAGE = ` Only subscribers can deploy virtual machines in this room! Go to your PROFILE
page to subscribe (if you have not already).`;
export const NETWORK_ROOM_MESSAGE = 'You have access to this room for a limited time';
